import type { EntryPoint, EntryPointComponent } from 'react-relay';
import type { OperationType } from 'relay-runtime';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

type ServiceDeskSlaEntrypointComponent = EntryPointComponent<
	Record<string, OperationType>,
	// oxlint-disable-next-line @typescript-eslint/no-explicit-any
	Record<string, EntryPoint<any, any> | undefined>,
	{},
	{} | null
>;

export const serviceDeskSlaEntrypoint: EntryPoint<ServiceDeskSlaEntrypointComponent, {}> =
	createEntryPoint({
		root: JSResourceForUserVisible<ServiceDeskSlaEntrypointComponent>(
			/* webpackChunkName: "async-servicedesk-sla-entrypoint" */ './ServiceDeskSlaPageEntrypoint.tsx',
			{
				entryFsSsrLiftImportToModule: true,
			},
		),
		getPreloadProps: () => ({
			queries: {},
			extraProps: {},
		}),
	});
